import React, { useState } from 'react';
import { styled } from '@mui/system';
import List from '@mui/material/List/index';
import Divider from '@mui/material/Divider/index';
import Paper from '@mui/material/Paper/index';
import { EventListItem } from './event-list-item';

const EventsPaper = styled(Paper)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    marginTop: 56
  },
  [theme.breakpoints.down('md')]: {
    height: 'calc(100% - 52px)',
    overflowY: 'auto',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0
  }
}));

const EventsListContainer = styled(List)(({ theme }) => ({
  height: '100%',
  padding: 0,
  overflow: 'hidden auto',
  [theme.breakpoints.up('md')]: {
    '&::-webkit-scrollbar-track': {
      WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
      borderRadius: 10,
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar': {
      width: 8,
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
      backgroundColor: '#a0a0a0'
    }
  }
}));

const EventsList = props => {
  const {
    groupedEvents,
    handleClick,
    handleHover,
    handleEventHover,
    handleGroupHover,
    handleGroupClosing,
    account,
    isMobile,
    syncSelectedDevicesWithStore
  } = props;

  const [hoverEventId, setHoverEventId] = useState(null);

  return (
    <EventsPaper className="events" elevation={0}>
      <EventsListContainer dense={false}>
        {groupedEvents.map((item, i) => (
          <React.Fragment key={i}>
            <EventListItem
              eventsGroup={item}
              account={account}
              isMobile={isMobile}
              handleClick={handleClick}
              handleHover={handleHover}
              handleGroupHover={handleGroupHover}
              handleEventHover={handleEventHover}
              handleGroupClosing={handleGroupClosing}
              itemIndex={i}
              hoverEventId={hoverEventId}
              setHoverEventId={setHoverEventId}
              syncSelectedDevicesWithStore={syncSelectedDevicesWithStore}
            />
            <Divider />
          </React.Fragment>
        ))}
      </EventsListContainer>
    </EventsPaper>
  );
};

export default React.memo(EventsList);
